<template>
  <div class="flex flex-col lg:flex-row">
    <ul class="flex list-reset border border-grey-light rounded font-sans">
      <li class="page-item" :class="{disabled: pagination.currentPage <= 1}" title="Pertama">
        <span v-if="pagination.currentPage <= 1" class="block text-xs text-grey border-r border-grey-light px-3 py-2 cursor-default">
          <v-icon name="angle-double-left" scale="0.6" />
        </span>
        <a v-else class="block text-xs hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 no-underline" @click.prevent="changePage(1)" href="#">
          <v-icon name="angle-double-left" scale="0.6" />
        </a>
      </li>
      <li class="page-item" :class="{disabled: pagination.currentPage <= 1}" title="Sebelumnya">
        <span v-if="pagination.currentPage <= 1" class="block text-xs text-grey border-r border-grey-light px-3 py-2 cursor-default">
          <v-icon name="angle-left" scale="0.6" />
        </span>
        <a v-else class="block text-xs hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 no-underline" @click.prevent="changePage(pagination.currentPage - 1)" href="#">
          <v-icon name="angle-left" scale="0.6" />
        </a>
      </li>
      <li class="page-item" v-for="page in pages" v-bind:key="page" :class="{active: isCurrentPage(page), disabled: isCurrentPage(page)}">
        <span v-if="isCurrentPage(page)" class="block text-xs text-white bg-blue border-r border-blue px-3 py-2 cursor-default">{{ page }}</span>
        <a v-else class="block text-xs hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 no-underline" @click.prevent="changePage(page)" href="#">{{ page }}</a>
      </li>
      <li class="page-item" :class="{disabled: pagination.currentPage >= pagination.lastPage}" title="Selanjutnya">
        <span v-if="pagination.currentPage >= pagination.lastPage" class="block text-xs text-grey border-r border-grey-light px-3 py-2">
          <v-icon name="angle-right" scale="0.6" />
        </span>
        <a v-else class="block text-xs hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 no-underline" @click.prevent="changePage(pagination.currentPage + 1)" href="#">
          <v-icon name="angle-right" scale="0.6" />
        </a>
      </li>
      <li class="page-item" :class="{disabled: pagination.currentPage >= pagination.lastPage}" title="Terakhir">
        <span v-if="pagination.currentPage >= pagination.lastPage" class="block text-xs text-grey border-grey-light px-3 py-2">
          <v-icon name="angle-double-right" scale="0.6" />
        </span>
        <a v-else class="block text-xs hover:text-white hover:bg-blue text-blue border-grey-light px-3 py-2 no-underline" @click.prevent="changePage(pagination.lastPage)" href="#">
          <v-icon name="angle-double-right" scale="0.6" />
        </a>
      </li>
    </ul>
    <div class="flex text-xs text-grey-dark items-center lg:ml-4 lg:mt-0 mt-2">
      <span>item ke {{ pagination.from }}<span v-if="pagination.from !== pagination.to">-{{ pagination.to }}</span> dari {{ pagination.total }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      required: true
    }
  },
  methods: {
    isCurrentPage (page) {
      return this.pagination.currentPage === page
    },
    changePage (page) {
      if (page > this.pagination.lastPage) {
        page = this.pagination.lastPage
      }
      this.pagination.currentPage = page
      this.$emit('paginate')
    }
  },
  computed: {
    pages () {
      let pages = []
      let from = this.pagination.currentPage - Math.ceil(this.offset / 2)
      if (from < 1) {
        from = 1
      }
      let to = from + this.offset - 1
      if (to > this.pagination.lastPage) {
        to = this.pagination.lastPage
      }
      while (from <= to) {
        pages.push(from)
        from++
      }
      return pages
    }
  }
}
</script>

<style>
/* .pagination {
  margin-top: 32px;
} */
</style>
